<template>
  <auth-layout>
    <ValidationObserver ref="obs">
      <form @submit.prevent="submit()" class="text-xs-center" ref="form">
        <v-alert v-if="error" outlined color="red">{{error}}</v-alert>

        <v-text-field
          outline
          name="email"
          label="Email address"
          type="email"
          v-model="user.email"
          append-icon="mdi-email"
          required
        ></v-text-field>
        <ValidationProvider name="password" rules="required|min:5">
          <v-text-field
            slot-scope="{
                errors,
                valid
              }"
            :error-messages="errors"
            :success="valid"
            outline
            name="password"
            label="Password"
            type="password"
            append-icon="mdi-lock"
            v-model="user.password"
            required
          ></v-text-field>
        </ValidationProvider>
        <v-row>
          <v-col>
            <v-btn
              block
              router
              :loading="$store.state.fetching"
              :to="{name: 'app.password.forgot'}"
            >{{$t('app.forgot_password')}}</v-btn>
          </v-col>
          <v-col>
            <v-btn
              block
              router
              :loading="$store.state.fetching"
              :to="{name: 'app.register'}"
            >{{$t('app.register')}}</v-btn>
          </v-col>
          <v-col>
            <v-btn
              block
              color="primary"
              type="submit"
              :loading="$store.state.fetching"
            >{{$t('app.signin')}}</v-btn>
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </auth-layout>
</template>
<script>
import AuthLayout from "./AuthLayout";
import { firebase } from "@firebase/app";
import "@firebase/auth";
import { mapActions } from "vuex";

import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "Login",
  components: { AuthLayout, ValidationProvider, ValidationObserver },
  data() {
    return {
      error: "",
      user: { email: "", password: "" }
    };
  },
  mounted() {
    firebase.auth().languageCode = "fr";
  },
  methods: {
    ...mapActions(["setUser", "toogleFetching", "updateAvatar"]),
    async submit() {
      const result = await this.$refs.obs.validate();
      if (result) {
        this.toogleFetching();
        firebase
          .auth()
          .signInWithEmailAndPassword(this.user.email, this.user.password)
          .then(user => {
            this.toogleFetching();
            this.setUser(user);
            this.$router.push("/dashboard");
          })
          .catch(err => {
            this.toogleFetching();
            this.setAuthError(err.code);
          });
      }
    },
    setAuthError(code) {
      switch (code) {
        case "auth/wrong-password":
          this.error = this.$t("app.wrong_password");
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style scoped>
.l-auth__user-icon {
  font-size: 8rem;
}
</style>